<template lang="pug">
	//- Обычное сообщение пользователя или агента (а также сообщение об ошибке)
	.ai-chat-message-content
		//- Сообщение пользователя, полученное голосовым вводом, помечаем иконкой микрофона
		i.fa.fa-microphone.ai-chat-message-voice-icon(v-if="message.options && message.options.voice" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Voice message'}")
		//- Текст экранируется, выделение **текст** заменяется на элемент-обёртку (см. AIAgent.formatMessageText)
		span(v-html="formatMessageText(message.message)")
		//- Переход в созданную агентом копию креатива (например, после отвязки от репозитория)
		.ai-chat-message-actions(v-if="message.options && message.options.openProjectId && isCreativeAvailable(message.options.openProjectId)")
			button.btn.btn-primary.btn-sm(type="button" v-on:click="openCreative(message.options.openProjectId)")
				i.fa.fa-folder-open
				span Open creative
</template>

<script>
	import { Creative } 			from './../../services/Creative'
	import { AIAgent } 			from './../../services/AIAgent'

	export default {
		name: "AIAgentMessageText",
		props: ['message'],
		methods: {
			formatMessageText(text) {

				return AIAgent.formatMessageText(text);

			},
			isCreativeAvailable(creativeId) {

				return !!Creative.getCreative(creativeId);

			},
			openCreative(creativeId) {

				Creative.selectCreative(creativeId);

			}
		}
	}
</script>

<style lang="sass">

	// Оформление сообщения по роли - общее для всех типов сообщений (остальные типы переопределяют фон и рамку,
	// поэтому этот компонент импортируется в AIAgent.History.vue первым)
	.ai-chat
		.ai-chat-history
			.ai-chat-message
				display: flex
				flex-direction: row
				justify-content: flex-start
				margin-bottom: 8px

				.ai-chat-message-content
					max-width: 80%
					padding: 6px 10px
					border-radius: 8px
					font-size: 14px
					line-height: 18px
					white-space: pre-wrap
					word-break: break-word

					// Слова, выделенные моделью двумя звёздочками (**текст**)
					.ai-chat-highlight
						font-weight: 600
						color: var(--info)
						padding: 0 3px
						border-radius: 3px
						//background-color: rgba(32,168,216,0.25)
						//box-shadow: inset 0 -1px 0 rgba(32,168,216,0.8)

					// Заголовки ### в тексте сообщения
					.ai-chat-heading
						font-weight: 600
						font-size: 15px
						line-height: 20px
						margin: 6px 0 4px

						&.level-1, &.level-2
							font-size: 17px

					// Цитаты > в тексте сообщения
					.ai-chat-quote
						margin: 4px 0
						padding: 2px 0 2px 10px
						border-left: 3px solid rgba(32,168,216,0.8)
						background-color: rgba(255,255,255,0.05)
						border-radius: 0 4px 4px 0
						color: rgba(255,255,255,0.75)
						font-style: italic

					// Разделитель --- в тексте сообщения
					.ai-chat-separator
						margin: 8px 0
						border: 0
						border-top: 1px solid rgba(255,255,255,0.25)

					// Таблицы в тексте сообщения
					.ai-chat-table
						white-space: normal
						border-collapse: collapse
						margin: 6px 0
						font-size: 13px
						line-height: 17px

						th, td
							padding: 4px 8px
							border: 1px solid rgba(255,255,255,0.25)
							vertical-align: top

						th
							font-weight: 600
							background-color: rgba(255,255,255,0.12)

				&.user
					.ai-chat-message-content
						background-color: #20a8d8
						color: #fff

						.ai-chat-highlight
							background-color: rgba(255,255,255,0.2)
							box-shadow: inset 0 -1px 0 rgba(255,255,255,0.7)

						.ai-chat-quote
							border-left-color: rgba(255,255,255,0.8)
							color: rgba(255,255,255,0.9)

						.ai-chat-separator
							border-top-color: rgba(255,255,255,0.5)

				&.assistant
					.ai-chat-message-content
						background-color: rgba(255,255,255,0.15)
						border: 1px solid #23282c

				&.error
					.ai-chat-message-content
						border-color: #f86c6b
						color: #f86c6b

				// Кнопки действий в обычном сообщении агента (например, переход в созданную копию креатива)
				.ai-chat-message-actions
					margin-top: 8px

					.btn i.fa
						margin-right: 6px

				// Иконка микрофона у сообщений пользователя, полученных голосовым вводом
				.ai-chat-message-voice-icon
					margin-right: 6px
					opacity: 0.7

</style>
